<template>
  <div class="policy-detach">
    <custom-scrollbar>
      <div
        class="crm-container policy-container"
      >
        <div class="description">
          Вы уверены, что хотите открепить полис?
        </div>
        <div class="crm-wrapper-buttons">
          <base-button
            :type="$const.SECONDARY_BUTTON"
            class="crm-button"
            @click="onClickClose"
          >
            Отменить
          </base-button>

          <base-button
            :type="$const.WARNING_BUTTON"
            :loading="isDetaching"
            class="crm-button"
            @click="onClickDetach"
          >
            Открепить
          </base-button>
        </div>
      </div>
    </custom-scrollbar>
  </div>
</template>

<script>
import { mixinRoles } from '@/mixins';
import Bus from '@/eventBus';

import {
  BaseButton,
} from '@/components/base';

export default {
  name: 'PolicyDetachDopModal',
  components: {
    BaseButton,
  },
  mixins: [mixinRoles],
  props: {
    personId: {
      type: Number,
      default: null,
    },
    policyId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isDetaching: false,
    };
  },
  methods: {
    onClickClose() {
      this.$emit('vuedals:close');
    },
    async onClickDetach() {
      this.isDetaching = true;

      if (!this.policyId) {
        Bus.$emit('patient:update');
        this.$emit('vuedals:close');
      } else {
        try {
          await this.$store.dispatch(this.$types.PATIENT_POLICY_DETACH_DOP, { policyId: this.policyId, personId: this.personId });
        } catch (e) {
          console.log(e);
        } finally {
          this.isDetaching = false;
          Bus.$emit('patient:update');
          Bus.$emit('patients:update');
          this.$emit('vuedals:close');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.policy-container {
  flex-direction: column;
  align-items: center;
}
.crm-wrapper-buttons {
  margin-top: 35px;
}
.description {
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
}
</style>
